import { render, staticRenderFns } from "./VisualizacaoBase.vue?vue&type=template&id=0d03b4f9&"
import script from "./VisualizacaoBase.vue?vue&type=script&lang=js&"
export * from "./VisualizacaoBase.vue?vue&type=script&lang=js&"
import style0 from "./VisualizacaoBase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports